import { shape, string, number } from 'prop-types';

const recoverableErrorTypes = shape({
  response: shape({
    status: number.isRequired,
    data: shape({
      error: string.isRequired,
      errorMessage: string.isRequired,
    }).isRequired,
  }),
});

export default recoverableErrorTypes;
